import React from 'react';
import Male from './Male';
import MaleFoi01 from './characters/Male_foi_01';
import MaleFoi02 from './characters/Male_foi_02';
import MaleStanding01 from './characters/Male_Standing_01';
import MaleStanding02 from './characters/Male_Standing_02';
import MaleStanding03 from './characters/Male_Standing_03';
import MaleCrouch01 from './characters/Male_Crouch_01';
import FemaleStanding02 from './characters/Female_Standing_02';
import FemaleStanding03 from './characters/Female_Standing_03';
import FemaleFoi01 from './characters/Female_foi_01';
import FemaleCrouch02 from './characters/Female_Crouch_02';

function deg2rad(degree: number): number {
    return degree * Math.PI/180;
}

type Props = {
    isGuySelected: boolean;
    onGuyPointerOver: () => void;
    onGuyPointerOut: () => void;
    onGuyClick: () => void;
}

export default function Characters({ isGuySelected, onGuyClick, onGuyPointerOver, onGuyPointerOut }: Props) {
    return (
        <>
            <Male model="Male_Walk_02" number={1} originalPathX={160} originalPosX={160} originalPathY={113} originalPosY={113} pathX={100} pathY={13} />
            <Male model="Male_Walk_03" number={2} originalPathX={330} originalPosX={243} originalPathY={140} originalPosY={15} pathX={243} pathY={13} />
            <Male model="Male_Walk_01" number={3} originalPathX={243} originalPosX={183} originalPathY={88} originalPosY={70} pathX={183} pathY={13} />

            <MaleStanding01 scale={[5, 5, 5]} position={[80, 0, 39]} rotation={[0, deg2rad(180), 0]} />
            <MaleStanding02 scale={[5, 5, 5]} position={[100, 0, 20]} rotation={[0, deg2rad(-70), 0]} />
            <MaleCrouch01 scale={[5, 5, 5]} position={[115, 0, 25]} rotation={[0, deg2rad(30), 0]} />
            <MaleStanding03 scale={[5, 5, 5]} position={[150, 0, 80]} rotation={[0, deg2rad(-75), 0]} />

            <MaleFoi01 scale={[5, 5, 5]} position={[190, 0, 40]} rotation={[0, deg2rad(60), 0]} />
            <FemaleStanding02 scale={[5, 5, 5]} position={[195, 0, 40]} rotation={[0, deg2rad(-60), 0]} />

            <FemaleStanding03 scale={[5, 5, 5]} position={[250, 0, 77]} rotation={[0, deg2rad(20), 0]} />
            <FemaleCrouch02 scale={[5, 5, 5]} position={[255, 0, 79]} rotation={[0, deg2rad(-10), 0]} />

            <FemaleFoi01 scale={[5, 5, 5]} position={[350, 0, 55]} rotation={[0, deg2rad(120), 0]} />
            <group position={[340, 0, 43]} rotation={[0, deg2rad(80), 0]}>
                <MaleFoi02
                    scale={[5, 5, 5]}
                    isSelected={isGuySelected}
                    onClick={onGuyClick}
                    onPointerOver={onGuyPointerOver}
                    onPointerOut={onGuyPointerOut}
                />
            </group>
            <FemaleStanding02 scale={[5, 5, 5]} position={[355, 0, 38]} rotation={[0, deg2rad(-85), 0]} />
        </>
    );
}